import { APIModel } from '@shared/interfaces';
import { PollingStatus } from './polling-status.enum';
import { StatusProvider } from './status-provider.enum';

export class CompanyLinkSync implements APIModel {
    id = -1;
    createdAt = new Date();
    status: PollingStatus = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.createdAt = data.created_at ? new Date(data.created_at) : this.createdAt;
        this.status = data.status ?? PollingStatus.Init;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;

        return this;
    }
}
